import * as React from 'react';
import { useSelector } from 'react-redux';
import '../assets/scss/loader.scss';
import { Box, Backdrop, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppLoaderIcon from './UtilityComponents/AppLoaderIcon';
const Loader = () => {
    const loaderCounter = useSelector((state) => state.loader.ActiveHTTPRequests);
    const immediateCounter = useSelector((state) => state.loader.ImmediateActiveRequests);
    const showLoaderMessage = useSelector((state) => state.User.loaderMessage);
    const [t] = useTranslation('global');
    const [showLoader, setShowLoader] = React.useState(true);
    React.useEffect(() => {
        if (immediateCounter > 0) {
            setShowLoader(loaderCounter > 0);
            return;
        }
        const timer = setTimeout(() => {
            setShowLoader(loaderCounter > 0);
        }, 50);
        return () => clearTimeout(timer);
    }, [loaderCounter, immediateCounter]);
    return (React.createElement(Box, { key: `${showLoader}` },
        React.createElement(Backdrop, { sx: { color: '#fff', zIndex: 9999 }, open: showLoader },
            React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 } },
                React.createElement(AppLoaderIcon, null),
                React.createElement(Typography, { textAlign: 'center', sx: {
                        fontSize: '14px',
                        fontWeight: 600,
                        letterSpacing: '0.01em',
                        color: '#fff',
                    } }, showLoaderMessage || t('GENERIC_STRINGS.LoaderMessage'))))));
};
export default React.memo(Loader);
